module.exports = __webpack_public_path__ + "static/media/6_review@2x.9027bcc7.jpg";